import { onConnect } from '@reatom/framework'

import { AsyncStateN, pipe, Result } from '@blade/std-lib'
import { newTxEvent } from '@root/entities/realtime/atoms/new-tx-event'
import { fetchTopTradersRequestAction } from '@root/features/trade/top-traders'
import { reatomDataTable } from '@root/shared/ui-kit'

import { holdersSwapUpdateHandler } from '../../common/holders-swap-update-handler'

import { createTopTradersTableColumns } from './reatom-top-traders-columns'

import type { PairModel } from '@root/entities/pair'
import type { Maker } from '@root/entities/trade'
import type { TableData } from '@root/shared/ui-kit'

export const reatomTopTradersTable = (options: { pair: PairModel }) => {
  const tableModel = reatomDataTable({
    columns: createTopTradersTableColumns({ pair: options.pair }),
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'pair-top-traders-table',
    initialSorting: {
      sortColumn: 'rank',
      sortDirection: 'desc',
    },
    loadItems: async (ctx, { filters }) => {
      const result = await fetchTopTradersRequestAction(ctx, {
        network: options.pair.network,
        pairAddress: options.pair.address,
      })

      return pipe(
        result,
        Result.map(
          (data): TableData<Maker.RankedMaker> => ({
            data: data
              .filter((trader) => {
                const { maker } = filters
                if (
                  maker &&
                  maker.type === 'string' &&
                  maker.operator === 'eq'
                ) {
                  return trader.address === maker.value
                }
                return true
              })
              .sort((a, b) => a.rank - b.rank),
            hasNext: false,
          }),
        ),
      )
    },
    getId: (item) => item.address,
  })

  onConnect(tableModel, () => {
    const unsubscribe = newTxEvent.onCall((ctx, swap) => {
      if (
        swap.pairAddress === options.pair.address &&
        swap.network === options.pair.network
      ) {
        tableModel.setState(
          ctx,
          AsyncStateN.map((prev) => {
            return { ...prev, data: holdersSwapUpdateHandler(prev.data, swap) }
          }),
        )
      }
    })

    return () => {
      unsubscribe()
    }
  })

  return tableModel
}
